import { Component, EventEmitter, Injectable, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { ConfirmCreatePaymentComponent } from 'src/app/Product/confirm-create-payment/confirm-create-payment.component';
import * as countrycitystatejson from 'countrycitystatejson';
import { VendorService } from 'src/app/_services/vendor.service';
import { CommonService } from 'src/app/_services/common.service';
import { _isNumberValue } from '@angular/cdk/coercion';
import { ZipCodeService } from 'src/app/_services/zip-code.service';
import { ServiceTypeService } from 'src/app/_services/service-type.service';

interface Country {
  shortName: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-create-payement',
  templateUrl: './create-payement.component.html',
  styleUrls: ['./create-payement.component.css'],
})
export class CreatePayementComponent implements OnInit {
  breakpoint: number;

  constructor(
    private vendorService: VendorService,
    private authService: AuthService,
    private alertService: AlertService,
    private zipCodeService: ZipCodeService,
    public commonService: CommonService,
    public serviceTypeService: ServiceTypeService,    
    public dialog: MatDialog
  ) { }

  submitted: boolean = true;
  data: any;
  countries: Country[];
  states: any[];
  cities: string[];
  private countryData = countrycitystatejson;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  PaymentServiceTypes: any[]
  @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;

  ngOnInit(): void {
    // console.log(countrycitystatejson)
    const token = this.authService.getToken();
    const id = this.authService.getRegistredUserDetails().customerId;
    this.vendorService.AllActivevendors(token, id).subscribe((response) => {
      this.data = response.map(obj => obj.vendorId);
      console.log(this.data)
    })

    // if (this.businessTypeForm.value.Country) {
    //   this.states = this.getStatesByCountry(this.businessTypeForm.value.Country);
    //   console.log(this.states)
    //   this.businessTypeForm.get('PropertyAddressState').enable();
    // }

    this.serviceTypeService.getServiceTypeList(token).subscribe((response) => {
      this.PaymentServiceTypes = response;
      console.log(response)

        // Set default if only one service type exists
  if (this.PaymentServiceTypes.length === 1) {
    this.businessTypeForm.get('serviceType')?.setValue(this.PaymentServiceTypes[0].paymentServiceTypeId);
  }
      
    })

  }

  // onStateClick(event) {
  //   var state = event.value;
  //   console.log("statee", state);
  //   if (state) {
  //     this.cities = this.getCitiesByState(this.businessTypeForm.value.Country, state);
  //     console.log(this.cities)
  //     this.businessTypeForm.get('PropertyAddressCity').enable();
  //   }
  // }

  businessTypeForm: FormGroup = new FormGroup(
    {
      Country: new FormControl('US'),
      serviceType: new FormControl('',[Validators.required]),
      ServiceDate: new FormControl(''),
      ServiceCode: new FormControl('', [Validators.required]),
      ServiceDescription: new FormControl('', [Validators.required]),
      ServiceCharge: new FormControl('', [Validators.required]),
      LoanId: new FormControl('', [Validators.required]),
      VendorId: new FormControl('', [Validators.required]),
      PropertyAddressStreet: new FormControl('', [Validators.required]),
      PropertyAddressCity: new FormControl('', [Validators.required]),
      PropertyAddressState: new FormControl('',
        [Validators.required]),
      PropertyAddressZip: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      PayeeType: new FormControl('Borrower'),
      PayeeNameFirst: new FormControl('', [Validators.required]),
      PayeeNameLast: new FormControl('', [Validators.required]),
      PayeeCompany: new FormControl('abcd'),
      PayeePhone: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      PayeeEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),

      TrackingNo: new FormControl(this.commonService.generate_uuidv4()),
      VendorCompany: new FormControl(''),
      VendorContact: new FormControl(''),
      VendorAddressStreet: new FormControl('987 AFS TEST'),
      VendorAddressCity: new FormControl('Arcadia'),
      VendorAddressState: new FormControl('CA'),
      VendorAddressZip: new FormControl('91007'),
      VendorTaxId: new FormControl(''),
      VendorTinCode: new FormControl(''),
      VendorContactEmail: new FormControl(''),
      VendorContactPhone: new FormControl(''),
      VendorWebsiteURL: new FormControl(''),
      InvoiceNo: new FormControl("AFS-TEST"),
      PreApprovedAccountId: new FormControl(''),
      SendPayeeEmail: new FormControl('Yes'),
      RemitToId: new FormControl(null),
      SettlementRequired: new FormControl('No'),
      SettleDate: new FormControl(''),
      CompletionRequired: new FormControl('No'),
      RemitDate: new FormControl(''),
      CustTransactionId: new FormControl(null),
      AFSTransactionId: new FormControl(null),
      ContractId: new FormControl(null),
      ClientPreferredResponseIdentifier: new FormControl(null),
      ServiceItems: new FormControl(null),

      //vendor info
      vendorName: new FormControl(''),
      address: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      zipCode: new FormControl(''),
      country: new FormControl(''),
      payeeLandmark: new FormControl(''),
      propertyCountry: new FormControl(''),
      vendorNameId: new FormControl(''),
    })


  openDialog(): void {
    const dialogRef = this.dialog.open(ConfirmCreatePaymentComponent, {
      width: '500px',
      disableClose: true,
      data: {
        PaymentServiceTypeId: this.businessTypeForm.value.serviceType.toString(),
        ServiceDate: this.businessTypeForm.value.ServiceDate,
        ServiceCode: this.businessTypeForm.value.ServiceCode,
        ServiceDescription: this.businessTypeForm.value.ServiceDescription,
        ServiceCharge: this.businessTypeForm.value.ServiceCharge.toString(),
        LoanId: this.businessTypeForm.value.LoanId,
        VendorId: this.businessTypeForm.value.VendorId,
        PropertyAddressStreet: this.businessTypeForm.value.PropertyAddressStreet,
        PropertyAddressCity: this.businessTypeForm.value.PropertyAddressCity,
        PropertyAddressState: this.businessTypeForm.value.PropertyAddressState,
        PropertyAddressZip: this.businessTypeForm.value.PropertyAddressZip.toString(),
        PayeeType: this.businessTypeForm.value.PayeeType,
        PayeeNameFirst: this.businessTypeForm.value.PayeeNameFirst,
        PayeeNameLast: this.businessTypeForm.value.PayeeNameLast,
        PayeeCompany: this.businessTypeForm.value.PayeeCompany,
        PayeePhone: this.businessTypeForm.value.PayeePhone,
        PayeeEmail: this.businessTypeForm.value.PayeeEmail,
        payeeLandmark: this.businessTypeForm.value.payeeLandmark,
        TrackingNo: this.commonService.generate_uuidv4(),
        VendorCompany: this.businessTypeForm.value.VendorCompany,
        VendorContact: this.businessTypeForm.value.VendorContact,
        VendorAddressStreet: this.businessTypeForm.value.VendorAddressStreet,
        VendorAddressCity: this.businessTypeForm.value.VendorAddressCity,
        VendorAddressState: this.businessTypeForm.value.VendorAddressState,
        VendorAddressZip: this.businessTypeForm.value.VendorAddressZip,
        VendorTaxId: this.businessTypeForm.value.VendorTaxId,
        VendorTinCode: this.businessTypeForm.value.VendorTinCode,
        VendorContactEmail: this.businessTypeForm.value.VendorContactEmail,
        VendorContactPhone: this.businessTypeForm.value.VendorContactPhone,
        VendorWebsiteURL: this.businessTypeForm.value.VendorWebsiteURL,
        InvoiceNo: this.businessTypeForm.value.InvoiceNo,
        PreApprovedAccountId: this.businessTypeForm.value.PreApprovedAccountId,
        SendPayeeEmail: this.businessTypeForm.value.SendPayeeEmail,
        remitToId: this.businessTypeForm.value.RemitToId,
        SettlementRequired: this.businessTypeForm.value.SettlementRequired,
        settleDate: this.businessTypeForm.value.SettleDate,
        CompletionRequired: this.businessTypeForm.value.CompletionRequired,
        remitDate: this.businessTypeForm.value.RemitDate,
        CustTransactionId: this.businessTypeForm.value.CustTransactionId,
        AFSTransactionId: this.businessTypeForm.value.AFSTransactionId,
        ContractId: this.businessTypeForm.value.ContractId,
        ClientPreferredResponseIdentifier: this.businessTypeForm.value.ClientPreferredResponseIdentifier,
        ServiceItems: this.businessTypeForm.value.ServiceItems,
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.businessTypeForm.valid) {
      console.log(this.businessTypeForm.value)
      this.openDialog();
    }
    else {
      // this.alertService.error('Error!! Please enter valid data.', this.options);
    }
  }

  get forms() {
    return this.businessTypeForm.controls;
  }

  resetForm(): void {
    this.businessTypeForm.reset();
    this.businessTypeForm.markAsPristine();
    this.businessTypeForm.markAsUntouched();
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode == 101 || charCode == 69 || charCode == 43 || charCode == 45) {
      {
        this.businessTypeForm.controls['ServiceCharge'].setErrors({ 'incorrect': true })
        return false;
      }
    }
    return true;
  }

  // openDialogDialog() {
  //   const dialogRef = this.dialog.open(DialogexComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }

  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.businessTypeForm.value.PayeePhone = event.target.value
    }
  }

  onZipCodeChange(event) {
    var zip = event.target.value;
    this.cities = [];
    this.states = [];
    if (zip == null || zip.length == 0 || zip.length < 5)
      return;
    this.zipCodeService.getDetailByZip(zip).subscribe((data: any) => {
      console.log(data);
      if (data == null) {
        return;
      }
      this.cities = data.places.map((place: any) => place['city']);
      this.states = data.places.map((place: any) => place['state']);

    // Automatically set the first city and state if available
    if (this.cities.length > 0) {
      this.businessTypeForm.get('PropertyAddressCity').setValue(this.cities[0]);
    }
    if (this.states.length > 0) {
      this.businessTypeForm.get('PropertyAddressState').setValue(this.states[0]);
    }

    });
  }
  containsAgent(): boolean {
    const service = this.PaymentServiceTypes.find(service => service.paymentServiceTypeId === this.businessTypeForm.value.serviceType);
    return service && (service.serviceType.toLowerCase().includes('agent')||service.serviceType.toLowerCase().includes('fund'));
  }
  

}
